<template>
  <div class="card-wrap">
    <div class="content-title">数据表格</div>
    <div class="filter-header">
      <div style="flex: 1">
        <el-select class="select-item" v-model="tableFilter.demission" placeholder="请选择" @change="changeDimension">
          <el-option v-for="item in dimensionList" :label="item.label" :value="item.value" :key="item.value"> </el-option>
        </el-select>
        <el-button class="submit-btn" style="margin-left: 20px" @click="handleReset">重置</el-button>
      </div>
      <el-button class="submit-btn" style="margin-left: 12px" type="primary" @click="downExcel">导出</el-button>
    </div>
    <div class="table-wrap">
      <el-table
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        row-key="id"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          v-for="item of columns"
          :key="item.value"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          min-width="120"
          :fixed="true"
        >
          <template slot="header" v-if="item.tip">
            <span>
              {{ item.label }}
              <el-tooltip class="item" effect="dark" :content="item.tip" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>

          <template slot-scope="scope">
            <span>{{ scope.row[item.value] || scope.row[item.value] === 0 ? scope.row[item.value] : "--" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getConvertData } from "@/api/tools.js";
import { dimensionList, transFilterData } from "./config";
import { downLoadWrokSheet } from "@/utils/commonTools";

export default {
  name: "CardList",
  props: {
    filterData: Object,
    tableFilter: {
      type: Object,
      default: () => {
        return {
          demission: 2,
        };
      },
    },
  },
  data() {
    return {
      dimensionList,
      columns: [
        { label: "维度", value: "showName", width: "450px" },
        { label: "激活", value: "active_cnt", tip: "来源三方API" },
        { label: "活跃", value: "dau", tip: "来源三方API" },
        { label: "花费", value: "cost", tip: "来源三方API" },
        { label: "ROI", value: "roi", tip: "新增arpu/推广单价" },
        { label: "成本", value: "active_cost", tip: "来源三方API" },
        { label: "新增收入", value: "newUserIncome", tip: "来源数仓" },
        { label: "活跃收入", value: "income", tip: "来源数仓" },
        { label: "新增ARPU", value: "newUserArpu", tip: "新增收入/新增用户" },
        { label: "活跃ARPU", value: "arpu", tip: "活跃收入/活跃用户" },
      ],
      tableData: [],
      exportDataList: [],
      loading: false,
    };
  },
  methods: {
    searchData(data) {
      //维度相关
      const { pkg, platType, advertiserId, campaignId, campaignName, dateEnd, dateStart } = transFilterData(data);
      this.loading = true;
      getConvertData({
        pkg,
        platType,
        advertiserId,
        campaignId,
        campaignName,
        dateEnd,
        dateStart,
        demission: this.tableFilter.demission,
      }).then((res) => {
        if (res.code === "0000") {
          this.loading = false;
          const list = res.data.reportDataList;
          if (this.tableFilter.demission === 1) {
            this.tableData = list?.map((item) => {
              delete item.children;
              return item;
            });
          } else if (this.tableFilter.demission === 2) {
            this.tableData = list?.map((item) => {
              if (item.children) {
                item.children.map((child) => {
                  delete child.children;
                  return child;
                });
              }
              return item;
            });
          } else {
            this.tableData = list || [];
          }
          if (this.tableData.length > 0) {
            this.tableData[0].showName = "总计";
          }
          this.exportDataList = res.data.exportDataList;
        }
      });
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex == 0) {
        return "heji-row";
      }
      return "";
    },
    changeDimension() {
      this.searchData(this.filterData);
    },
    handleReset() {
      this.tableFilter.demission = 3;
      this.searchData(this.filterData);
    },
    downExcel() {
      const data = JSON.parse(JSON.stringify(this.exportDataList));
      const haderData = {};
      const columns = this.columns;
      columns.forEach((item) => {
        haderData[item.value] = item.label;
      });
      data[0].showName = "总计";
      downLoadWrokSheet(data, "数据总览.xlsx", haderData);
    },
  },
  watch: {
    tableFilter: {
      handler(val) {
        this.$emit("update:tableFilter", val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
::v-deep .heji-row {
  font-weight: bold;
  background: #f2f6fc;
}
.card-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  margin-bottom: 16px;
  .content-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 16px;
  }
  .filter-header {
    display: flex;
    align-items: center;
    .filter-label {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      margin-right: 8px;
      position: relative;
      top: -1px;
    }
  }
  .table-wrap {
    margin-top: 20px;
    .table-pagination {
      padding-right: 0px;
      /deep/.el-pagination {
        padding-right: 0px;
      }
    }
  }
}
</style>
